export var EdiExportPaths;
(function (EdiExportPaths) {
    EdiExportPaths["Assignment"] = "/assignment";
    EdiExportPaths["CustomDocument"] = "/customDocument";
    EdiExportPaths["Estimate"] = "/estimate";
    EdiExportPaths["Note"] = "/note";
    EdiExportPaths["Status"] = "/status";
})(EdiExportPaths || (EdiExportPaths = {}));
